import React, { useState, useEffect } from "react";
import CustomInput from "components/CustomInput";
import { useApolloClient, useMutation } from "@apollo/client";
import { UPDATE_EMAIL_ADDRESS } from "@ugg/shared/api/graphql/queries";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { isValidEmail } from "lib/form-helpers";
import { removeCookie } from "@ugg/shared/utils/cookies";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";

const EmailChange = (props) => {
  let { email } = props;

  // inputs
  let [newEmail, setNewEmail] = useState("");
  let [repeatNewEmail, setRepeatNewEmail] = useState("");
  let [password, setPassword] = useState("");

  // errors
  let [newEmailError, setNewEmailError] = useState();
  let [repeatNewEmailError, setRepeatNewEmailError] = useState();
  let [networkError, setNetworkError] = useState();

  useEffect(() => {
    if (newEmail == "" && !!email) {
      setNewEmail(email);
    }
  }, [email]);

  const [updateSettings, { loading, data, error }] = useMutation(UPDATE_EMAIL_ADDRESS, {
    variables: {
      newEmail: newEmail,
      oldEmail: email,
      password: password,
    },
    context: { clientName: "auth-api" },
    onCompleted: (data) => {
      let token = data && data.updateEmail && data.updateEmail.token;
      if (window && token) {
        removeCookie("authToken");
        // sessionStorage.setItem("authToken", token);
        // if (localStorage.getItem("authToken")) {
        //   localStorage.setItem("authToken", token);
        // }

        window.location.reload();
      }
    },
    onError: (error) => {
      if (error.message === "GraphQL error: unauthorized") {
        setNetworkError("Unauthorized");
      } else if (error.message === "GraphQL error: new_email_matches_old_email") {
        setNetworkError("New email matches current email");
      } else if (error.message === "GraphQL error: user_already_exists") {
        setNetworkError("An account with that email already exists");
      } else {
        setNetworkError("Unexpected network error.");
      }
    },
  });

  const verifyForm = () => {
    let hasErrors = false;
    setNetworkError("");

    if (!isValidEmail(newEmail)) {
      setNewEmailError("Invalid email address");
      hasErrors = true;
    } else {
      setNewEmailError();
    }

    if (newEmail !== repeatNewEmail) {
      setRepeatNewEmailError("Emails must match.");
      hasErrors = true;
    } else {
      setRepeatNewEmailError();
    }

    if (!hasErrors) {
      updateSettings();
    }
  };

  return (
    <div className="settings-section personal-information">
      <div className="section-content">
        <HeaderBullet className="mb-[24px]">Change Email</HeaderBullet>
        <div className="dob field-group">
          <div className="field-label">{"New Email"}</div>
          <CustomInput
            onChange={(e) => {
              setNewEmail(e.target.value);
            }}
            tabIndex={2}
            value={newEmail}
            error={newEmailError}
            type="text"
            className="bg-purple-100"
          />
        </div>
        <div className="dob field-group">
          <div className="field-label">{"Repeat New Email"}</div>
          <CustomInput
            onChange={(e) => {
              setRepeatNewEmail(e.target.value);
            }}
            tabIndex={3}
            value={repeatNewEmail}
            error={repeatNewEmailError}
            type="text"
          />
        </div>
        <div className="field-group">
          <div className="field-label">{"Current Password"}</div>
          <CustomInput value={password} onChange={(e) => setPassword(e.target.value)} tabIndex={4} type="password" />
        </div>
        <div className="dob field-group">
          <div className={"custom-input-container"}>
            <div className={"input-error-msg"}>{networkError}</div>
          </div>
          <ButtonSuccess
            className="save-settings-btn btn-light-blue"
            label="Save Changes"
            isLoading={loading}
            onClick={verifyForm}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailChange;
